import {css} from 'lit'; export default css`:host.draggable{-webkit-app-region:drag}`;
    